function checkProductAvailability() {
  const collections = document.querySelectorAll('.collection');
  if (collections.length == 0) return;

  const deliveryLocation = JSON.parse(window.localStorage.getItem('delivery_location'));
  if (!deliveryLocation) {
    collections.forEach((collection) => {
      const gopuffProductEls = collection.querySelectorAll('[data-gopuff-product-id]');
      gopuffProductEls.forEach((el) => {
        el.classList.remove('hidden');
      });
      const productToShowEl = collection.querySelector('[data-products-to-show]');
      if (productToShowEl) {
        const productsToShow = Number(productToShowEl.dataset.productsToShow);
        for (let i = productsToShow; i < gopuffProductEls.length; i++) {
          gopuffProductEls[i].classList.add('hidden');
        }
      }
    });
    return;
  };


  collections.forEach((collection) => {

    const gopuffProductIDs = [];

    collection.classList.add('loading');

    // const countContainer = document.getElementById('ProductCount');
    // const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // if (countContainer) {
    //   countContainer.textContent = 'products';
    // }
    // if (countContainerDesktop) {
    //   countContainerDesktop.textContent = 'products';
    // }

    collection.querySelectorAll('[data-gopuff-product-id]').forEach((el) => {
      el.classList.add('hidden');
      gopuffProductIDs.push(el.dataset.gopuffProductId);
    });

    if (gopuffProductIDs.length == 0) {
      collection.classList.remove('loading');
      return;
    }

    const params = {
      country_code: deliveryLocation.delivery_zone.country_code,
      location_id: deliveryLocation.delivery_zone.id,
      product_ids: gopuffProductIDs.join(','),
    };

    fetch(`${window.gopuffShopify.settings.api_base_url}/products?${new URLSearchParams(params)}`)
      .then((response) => response.json())
      .then((response) => {
        if (response.products) {
          let productAvailableCount = 0;
          response.products.forEach((product) => {
            const productEl = collection.querySelector(`[data-gopuff-product-id='${product.id}']`);
            if (productEl) {
              productEl.dataset.gopuffQuantity = product.quantity;
              productEl.classList.remove('hidden');
              productEl.classList.remove('unavailable');
              productEl.querySelectorAll('.card__badge').forEach((badgeEl) => {
                badgeEl.innerHTML = '';
              });

              if (product.quantity > 0) {
                productAvailableCount++;

                productEl.querySelectorAll('.card__badge').forEach((badgeEl) => {
                  if (badgeEl.dataset.defaultBadge) {
                    badgeEl.innerHTML = '';
                    const badgeSpan = document.createElement('span');
                    badgeSpan.classList.add('badge', 'badge--bottom-left', `color-${gopuffShopify.settings.custom_badge_color_scheme}`);
                    badgeSpan.textContent = badgeEl.dataset.defaultBadge;
                    badgeEl.appendChild(badgeSpan);
                  }
                });

              }
              else {
                productEl.classList.add('unavailable');

                productEl.querySelectorAll('.card__badge').forEach((badgeEl) => {
                  badgeEl.innerHTML = '';
                  const badgeSpan = document.createElement('span');
                  badgeSpan.classList.add('badge', 'badge--bottom-left', `color-${gopuffShopify.settings.sold_out_badge_color_scheme}`);
                  badgeSpan.textContent = gopuffShopify.strings.sold_out;
                  badgeEl.appendChild(badgeSpan);
                });
              }


              if (gopuffShopify.settings.show_inventory_quantity) {
                const productStatusEl = productEl.querySelector('.card__status-container');
                if (productStatusEl) {
                  if (product.quantity == 0) {
                    productStatusEl.textContent = gopuffShopify.strings.sold_out;
                  }
                  else {
                    productStatusEl.textContent = gopuffShopify.strings.inventory_in_stock_show_count.replace('{{ quantity }}', product.quantity);
                  }
                }
              }

              const quantityPillEl = productEl.querySelector('quantity-pill');
              if (quantityPillEl) {
                quantityPillEl.setMax(product.quantity);
                quantityPillEl.validateQtyRules();
              }
            }
          });

          // if (countContainer) {
          //   countContainer.textContent = `${productAvailableCount} products`;
          // }
          // if (countContainerDesktop) {
          //   countContainerDesktop.textContent = `${productAvailableCount} products`;
          // }

          collection.classList.remove('loading');

          const productToShowEl = collection.querySelector('[data-products-to-show]');
          if (productToShowEl) {
            const productsToShow = Number(productToShowEl.dataset.productsToShow);
            const unavailableProductsToShow = Math.max(0, productsToShow - productAvailableCount);

            const availableProductEls = collection.querySelectorAll(`:not(.unavailable)[data-gopuff-product-id]`);
            for (let i = productsToShow; i < availableProductEls.length; i++) {
              availableProductEls[i].classList.add('hidden');
            }

            const unavailableProductEls = collection.querySelectorAll(`.unavailable[data-gopuff-product-id]`);
            for (let i = unavailableProductsToShow; i < unavailableProductEls.length; i++) {
              unavailableProductEls[i].classList.add('hidden');
            }
          }
        }
      })
      .catch((e) => {
        collection.classList.remove('loading');
        collection.querySelectorAll('[data-gopuff-product-id]').forEach((el) => {
          el.classList.remove('hidden');
        });
        console.error(e);
      });
  });
}

checkProductAvailability();

window.addEventListener('load', () => {
  subscribe(PUB_SUB_EVENTS.deliveryLocationUpdate, checkProductAvailability);
});
